export const MockData = {
    "message": "File uploaded and processed successfully!",
    "file_data": {
        "id": 9,
        "file": "/media/pdfs/businessnameextract-Motovac-Mochudi_CXx9rZn.pdf",
        "uploaded_at": "2025-01-22T17:01:58.840199Z"
    },
    "process_result": [
        // {
        //     "key": "General Details",
        //     "value": "Motovac-Mochudi",
        //     "page": 1,
        // },
        {
            "key": "Business Name",
            "value": "Motovac-Mochudi",
            "page": 1,
        },
        {
            "key": "Business Name Status",
            "value": "Registered",
            "page": 1,
        },
        {
            "key": "Business Activities",
            "value": "Motor dealer",
            "page": 1,
        },
        {
            "key": "Registration Date",
            "value": "01 June 2016",
            "page": 1,
        },
        {
            "key": "Renewal Filing Month",
            "value": "June",
            "page": 1,
        },
        {
            "key": "Principal Place of Business",
            "value": "Plot 5661, Rampedi Ward, Mochudi, Botswana",
            "page": 1,
        },
        {
            "key": "Postal Address",
            "value": "P O Box 278, Mochudi, Botswana",
            "page": 1,
        },
        {
            "key": "Appointment Date",
            "value": "01 June 2016",
            "page": 1,
        },
        {
            "key": "Motovac-Mochudi",
            "value": "Extract generated as at 15 November 2023 12:05 PM CAT",
            "page": 1,
        },
        {
            "key": "Extract generated as at 15 November 2023 12:05 PM CAT",
            "value": "Page 1 of 1",
            "page": 1,
        },
        
    ]
}


export const MockJson = {
    "filename": "document.pdf",
    "status": "completed",
    "extracted_data": [
        {
            "patient_information": {
                "name": "Sarah Johnson",
                "dob": "03/15/1985",
                "mrn": "123456789",
                "gender": "Female",
                "physician": "Dr. Michael Chen, MD"
            },
            "dates": {
                "date_collected": "January 10, 2024",
                "date_reported": "January 12, 2024"
            }
        },
        {
            "test_results": {
                "test_name": "Complete Blood Count (CBC)",
                "results": [
                    {
                        "test_name": "White Blood Cells",
                        "result": 7.5,
                        "reference_range": "4.5-11.0",
                        "units": "K/uL"
                    },
                    {
                        "test_name": "Red Blood Cells",
                        "result": 4.8,
                        "reference_range": "4.0-5.5",
                        "units": "M/uL"
                    },
                    {
                        "test_name": "Hemoglobin",
                        "result": 14.2,
                        "reference_range": "12.0-16.0",
                        "units": "g/dL"
                    },
                    {
                        "test_name": "Hematocrit",
                        "result": 42,
                        "reference_range": "36.0-46.0",
                        "units": "%"
                    },
                    {
                        "test_name": "Platelets",
                        "result": 250,
                        "reference_range": "150-400",
                        "units": "K/uL"
                    },
                    {
                        "test_name": "MCV",
                        "result": 88,
                        "reference_range": "80-100",
                        "units": "fL"
                    },
                    {
                        "test_name": "MCH",
                        "result": 29.6,
                        "reference_range": "27-33",
                        "units": "pg"
                    }
                ],
                "interpretation": "All values within normal limits"
            }
        },
        {
            "review_information": {
                "reviewed_by": "Dr. Lisa Wang, Pathologist",
                "lab": "City Medical Laboratory",
                "license_number": "CA-12345"
            }
        }
    ],
    "raw_text_preview": "MEDICAL LABORATORY REPORT\n \nPatient Information\nName: Sarah Johnson\nDOB: 03/15/1985\nMRN: 123456789\nGender: Female\nPhysician: Dr. Michael Chen, MD\nDate Collected: January 10, 2024\nDate Reported: January 12, 2024\nTest Results - Complete Blood Count (CBC)\nTest Name\nResult\nReference Range\nUnits\nWhite Blood Cells\n7.5\n4.5-11.0\nK/uL\nRed Blood Cells\n4.8\n4.0-5.5\nM/uL\nHemoglobin\n14.2\n12.0-16.0\ng/dL\nHematocrit\n42.0\n36.0-46.0\n%\nPlatelets\n250\n150-400\nK/uL\nMCV\n88\n80-100\nfL\nMCH\n29.6\n27-33\npg\nInterpretation: Al..."
}